import { forwardRef, isValidElement, useState } from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { iconButtonGroupStyleBuilder, toggleButtonGroupStyleBuilder, toggleButtonStyleBuilder } from './toggleGroupStyleBuilder';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { v4 as uuidv4 } from 'uuid';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ToggleGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    defaultSelected,
    onChange,
    id,
    size,
    toggleButtonOptions,
    toggleWidth,
    ...rest
  } = _ref;
  const [selectedValue, setSelectedValue] = useState(defaultSelected ?? null);
  const handleToggleGroupChange = (event, value) => {
    setSelectedValue(value.toString());
    if (onChange) {
      onChange(event, value);
    }
  };
  const theme = useInterstateTheme();
  const _selected = toggleButtonOptions?.some(item => item.selected);
  const checkSelected = (selected, value, index) => {
    if (_selected) {
      return selected;
    }
    if (selectedValue === null) {
      return index === 0;
    }
    return selectedValue === value;
  };
  const toggleButtonMap = toggleButtonOptions?.map((option, index) => {
    const toggleGroupLength = toggleButtonOptions.length;
    const {
      children,
      icon,
      id,
      onClick,
      selected,
      value
    } = option;
    return /*#__PURE__*/_jsxs(ToggleButton, {
      id: id,
      value: value,
      onChange: handleToggleGroupChange,
      onClick: onClick,
      selected: checkSelected(selected, value, index),
      sx: mergeSxStyle(toggleButtonStyleBuilder(theme, size, index, toggleGroupLength), []),
      disableFocusRipple: true,
      disableRipple: true,
      "data-testid": option['data-testid'],
      children: [/*#__PURE__*/isValidElement(icon) ? /*#__PURE__*/_jsx(Box, {
        sx: iconButtonGroupStyleBuilder(size),
        children: icon
      }) : null, children]
    }, uuidv4());
  });
  const effectiveId = id || 'toggle-button-group-id';
  const effectiveDataTestId = rest['data-testid'] || 'toggle-button-group-data-testid';
  return /*#__PURE__*/_jsx(ToggleButtonGroup, {
    onChange: handleToggleGroupChange,
    sx: mergeSxStyle(toggleButtonGroupStyleBuilder(theme, size, toggleWidth), []),
    "data-testid": effectiveDataTestId,
    id: effectiveId,
    children: toggleButtonMap
  });
});
ToggleGroup.displayName = 'ToggleGroup';